import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PropertyAccessorService {

  constructor() { }

  public has(path: string, target: Object): boolean {
    if (typeof target !== 'object' || target === null) {
      return false;
    }
    const args = path.split('.');
    if (args.length === 1) {
      return target.hasOwnProperty(path);
    }
    const key = args.shift();
    return this.has(args.join('.'), target[key]);
  }

  public get<T>(path: string, target: Object, defaultValue = null): T {
    if (typeof target !== 'object' || target === null) {
      return defaultValue;
    }
    const args = path.split('.');
    if (args.length === 1) {
      return target.hasOwnProperty(path) ? target[path] : defaultValue;
    }
    const key = args.shift();
    return this.get<T>(args.join('.'), target[key]);
  }

  public set(path: string, value: any, target: Object): void {
    const args = path.split('.');
    if (args.length === 1) {
      target[path] = value;
      return;
    }
    let i = 0;
    let current = target[args[0]];
    while (i++ < args.length - 1) {
      if (current[args[i]] === undefined) {
        current[args[i]] = {};
      } else {
        current = current[args[i]];
      }
    }
    current[args[args.length - 1]] = value;
  }

}
